import { apiError } from '../../utils/errors';
import { ThirdPartyType } from '../../types';

export const postResendThirdPartyAccess = async (
  email: string,
  type: ThirdPartyType,
): Promise<void> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/access/third-party/resend`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      type,
    }),
  });

  const json = await response.json();

  if (!response.ok) {
    throw apiError(response.status, json?.message || 'Failed to resend code', json?.code);
  }
};
